module.exports = __webpack_public_path__ + "fonts/comfortaa-light-webfont.d1a387f0.ttf";